export const CREATE_LOT  = 'CREATE_LOT';
export const GET_LOT  = 'GET_LOT';
export const LOT_REQUEST  = 'LOT_REQUEST';
export const DELETE_LOT  = 'DELETE_LOT';
export const UPDATE_LOT  = 'UPDATE_LOT';
export const LOT_REQUEST_FAILURE  = 'LOT_REQUEST_FAILURE';